const About = () => {
  const aboutList = [
    {
      img: "/images/about1.png",
      txt1: "365일\u00A024시간\u00A0긴급출동",
      txt2: "자사명과 같이 언제든지 출동 가능합니다.",
    },
    {
      img: "/images/about2.png",
      txt1: "미해결시\u00A0비용\u00A0ZERO",
      txt2: "해결하지 못한다면 비용도 받지 않습니다.",
    },
    {
      img: "/images/about3.png",
      txt1: "타업체\u00A0실패현장\u00A0해결전문",
      txt2: "24시긴급출동누수는 베테랑 해결사입니다.",
    },
    {
      img: "/images/about4.png",
      txt1: "보험서류\u00A0무상제공",
      txt2: "누수소견서 및 보험관련 서류 전부 무료입니다",
    },
  ];
  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <h2 className="flex items-end justify-center gap-0.5 font-medium text-black">
          <img
            alt="logo"
            className="!relative w-auto h-full max-h-14 lg:max-h-24 py-1 object-contain cursor-pointer"
            src="/images/logo.png"
            width={531}
            height={65}
          />
          <span className="-mb-1.5 lg:-mb-2">의 약속 4가지</span>
        </h2>
        <p className="my-3 lg:my-5 lg:text-lg">-&nbsp;회사소개&nbsp;-</p>
        <p className="lg:text-lg text-black">
          24시긴급출동누수에서&nbsp;제공해드리는 4가지&nbsp;고객약속!
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-4 gap-4">
        {aboutList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full p-3 border rounded-3xl btn6 inline-block"
          >
            <div className=" relative w-full h-fit my-3 2xl:my-5 text-center">
              <p className="gmedium text-2xl 2xl:text-2xl text-black mb-3">
                {v.txt1}
              </p>
              <small className="text-font">{v.txt2}</small>
            </div>
            <div className="relative w-full h-fit rounded-t-xl overflow-hidden">
              <img
                className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                alt="img"
                src={v.img}
                width={517}
                height={499}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;
